
import { parseCoordinate, INVALID_COORDINATE, INVALID_NUMBER } from "../../../helpers/parsers.js";

export const valueGetter = (params) => {
  params.data ||= {};
  return parseCoordinate({value: params.data[params.colDef.field]})
};

export const valueFormatter = (params) => {
  if (params.value == null) return '';
  return parseCoordinate(params);
};

export const validateCoordinate = (props) => {
  const valid = props.value == null || 
                props.value == "" || 
                (typeof props.value == 'string' && props.value.split(',').length === 2 && props.value.split(',').every((s) => s !== INVALID_COORDINATE && s !== INVALID_NUMBER) );
  return valid
}